/**
 * Caminhos publicos do estabelecimento.
 *
 * O perfil vive em /[slug] e o wizard em /[slug]/agendar. Todo redirecionamento
 * que depende do modo passa por aqui, para que uma troca de unidade no wizard
 * caia no wizard da outra unidade, e no perfil caia no perfil.
 */

export type PublicBookingMode = "profile" | "booking";

export function buildSlugPath(
  slug: string | null | undefined,
  mode: PublicBookingMode = "profile"
): string {
  const normalized = String(slug || "").trim();
  if (!normalized) return "/";
  const base = `/${encodeURIComponent(normalized)}`;
  return mode === "booking" ? `${base}/agendar` : base;
}
